module.exports = __webpack_public_path__ + "img/UsedCardboardBoxes.87575ab6.png";